// extracted by mini-css-extract-plugin
export var actionButton = "_d2-0";
export var attachmentLine = "_d2-1";
export var fileInput = "_d2-2";
export var fileUploadWrapper = "_d2-4";
export var footer = "_d2-3";
export var modalContent = "_d2-5";
export var paperclip = "_d2-6";
export var quillEditor = "_d2-7";